import React from "react";
import "./Menu.css";

const Menu = ({ handleOnClick }) => {
  return (
    <div className="menu">
      <div className="background">Menu</div>
      <div className="menu-container">
        <ul className="options">
          <li className="nav">
            <a
              href="#concert"
              className="nav-link"
              onClick={handleOnClick}
            >
              More Than Just Music <span className="small-number">01</span>
            </a>
          </li>
          <li className="nav">
            <a
              href="#whatHappening"
              className="nav-link"
              onClick={handleOnClick}
            >
              What's Happening <span className="small-number">02</span>
            </a>
          </li>
          <li className="nav">
            <a
              href="#specialAppearance"
              className="nav-link"
              onClick={handleOnClick}
            >
              Special Appearances <span className="small-number">03</span>
            </a>
          </li>
          <li className="nav">
            <a href="#collaboration" className="nav-link" onClick={handleOnClick}>
            Taylor’s Clubs Collaboration <span className="small-number">04</span>
            </a>
          </li>
          <li className="nav">
            <a href="#faq" className="nav-link" onClick={handleOnClick}>
              Frequently Asked Questions{" "}
              <span className="small-number">05</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="menu-container right">
        <div className="information">
          <p className="title-menu">Follow Us</p>
          <div className="social-medias">
            <a
              href="https://www.facebook.com/TaylorsUniversityMY"
              target="_blank"
              rel="noreferrer"
              className="social-media mb-1"
            >
              facebook
            </a>
            <a
              href="https://www.instagram.com/taylorsuni/?hl=en"
              target="_blank"
              rel="noreferrer"
              className="social-media mb-1"
            >
              Instagram
            </a>
            <a
              href="https://www.youtube.com/user/taylors"
              target="_blank"
              rel="noreferrer"
              className="social-media mb-1"
            >
              youtube
            </a>
            <a
              href="https://twitter.com/TaylorsUni"
              target="_blank"
              rel="noreferrer"
              className="social-media mb-1"
            >
              twitter
            </a>
            <a
              href="https://www.tiktok.com/@taylors.uni?lang=en"
              target="_blank"
              rel="noreferrer"
              className="social-media mb-1"
            >
              tiktok
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
